import ReactDOM from "react-dom/client";
import App from "./App";
import "mantine-react-table/styles.css";
import "./styles/global.css";
import MantineGlobalLayout from "./components/layout/MantineGlobalLayout";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <MantineGlobalLayout>
    <App />
  </MantineGlobalLayout>
);
